<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <el-image
      :src="require('../../assets/images/brand/Scene-1.jpg')"
      fit="fill"
    ></el-image>
    <el-image
      :src="require('../../assets/images/brand/Scene-2.jpg')"
      fit="fill"
    ></el-image>
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  }
}
</script>
